import React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import Table from "./Table";
import { getTableData } from "./functions/tableOptions";

function openFile(url) {
  const p = new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.addEventListener("load", (e) => resolve(e.target.responseText));
    xhr.send();
  });
  return p;
}

function mapCSVToArray(csv) {
  return csv.split("\n").map((row) => row.split(","));
}

const Input = styled.input`
  width: 150px !important;
  border-radius: 5px;
`;

const Btn = styled.button`
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 0 10px;
  background-color: #0085c8;
`;

export const Articles = () => {
  const [q, setQ] = useState("");
  const [earningsData, setEarningsData] = useState([]);
  const [searchList, setSearchList] = useState([]);

  useEffect(() => {
    (async () => {
      const csv = await openFile("./2Q Performance.csv");
      setEarningsData(mapCSVToArray(csv));
    })();
  }, []);

  const search = (q) => {
    for (const data of earningsData) {
      if (data[0] == q) {
        return data;
      }
    }
  };

  const handleSubmit = (q) => {
    event.preventDefault();
    if (q != "") {
      setSearchList([...searchList, search(q)]);
    }
    setQ("");
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <form
        onSubmit={() => handleSubmit(q)}
        style={{ textAlign: "right", margin: "1.5px 0" }}
      >
        <Input
          type="text"
          name="input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <Btn onClick={() => handleSubmit(q)} type="submit">
          完了
        </Btn>
      </form>
      <Table data={getTableData(searchList)} />
    </div>
  );
};
